module.exports = __webpack_public_path__ + "img/symbol_8.110361b0.png";